import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  icons: {
    color: "#424242",
  },
  user: {
    paddingBottom: 16,
    marginBottom: 16,
    justifyContent: "space-between",
    display: "flex",
  },
  userIcon: {
    fontSize: "70px",
  },
  email: {
    fontSize: 13,
    marginLeft: 8,
  },
  infoUsuario: {
    marginTop: "10px",
  },
  actions: {
    justifyContent: "space-between",
    alignItems: "center",
    display: "flex",
  },
});
